import React, { memo, useContext } from 'react'
import { LanguageContext } from '../../../context/LanguageContext'

const ButtonGroup = ({ children, fontColor }) => {
    const { rtl } = useContext(LanguageContext)

    return (
        <div className={rtl ? 'btn-group rtl' : 'btn-group'}>
            {React.Children.toArray(children).map(child => {
                return React.cloneElement(child, { fontColor: fontColor, ...child.props })
            })}
        </div>
    )
}

export default memo(ButtonGroup)
